module.exports = __webpack_public_path__ + "static/media/aspen-media-logo.8c249cbe.jpg";